<x-login-card [loading]="loading()" (signIn)="signIn()">
  <img logo class="login-logo" src="beeking-logo-black.png" alt="BeeKing" />
  <x-card-subtitle subtitle>Welcome back. Sign in to continue.</x-card-subtitle>

  <div footer class="login-footer">
    <p>Need help? Contact support.</p>
    <p>
      <button type="button" (click)="onPrivacyPolicy()">Privacy Policy</button>
      &middot;
      <button type="button" (click)="onTermsAndConditions()">Terms &amp; Conditions</button>
    </p>
  </div>
</x-login-card>
